import { Route, withRouter, Switch, Redirect, NavLink } from "react-router-dom";
import * as React from "react";
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import "./static/Indexs.scss";
import {  IServicesProvider } from "../../di/IServicesProvider";
import App, { AppModel } from "../App/App";
import  Dexie  from 'dexie';
import Profile, { ProfileViewModel } from '../Profile/Profile';
import { SVGIcon, Drawer } from "react-md";
import NavDrawer from "../../component/NavDrawer/NavDrawer";
const MenuIcon = props => (
    <SVGIcon {...props}>
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </SVGIcon>
  );
export class IndexModel {
    @observable servicesProvder: IServicesProvider;
    @observable headerTitle: string = "Profile";
    @observable drawerVisible = true;
    @computed get user() {
        return this.servicesProvder.getUser();
    }

    constructor(servicesProvder: IServicesProvider ) {
        this.servicesProvder = servicesProvder;
    }
}

// tslint:disable-next-line:no-any
@observer class Index extends React.Component<{model: IndexModel, other: any, match: any, history: any}, {}> {
    private profileViewModel = new ProfileViewModel();
    
    componentDidMount() {
        if (window.location.pathname === "/") {
            this.props.history.push("/admin");
        }
    }
    // tslint:disable-next-line:no-any
    routesWithDrawer(items: any[]) {
        return(
                <div className="root">
                <div className="md-drawer-relative" >
                <div className="content-header">
                <MenuIcon 
                    className="hamburger" 
                    onClick={() =>  this.props.model.drawerVisible = !this.props.model.drawerVisible} 
                    size={34} 
                />

                <h2> {this.props.model.headerTitle}</h2>
                </div>
                    <div className="root">
                    <Switch>
                    <Route 
                        path="/admin" 
                        render={() => {
                            let model = new AppModel(this.props.model.servicesProvder);
                            return <App model={model} />;
                        }} 
                    />
                    <Route 
                        path={`/profile`}
                        render={(props) => {
                            this.profileViewModel.setServicesProvider(this.props.model.servicesProvder);
                            return  <Profile model={this.profileViewModel}/>; 
                        }} 
                    />
                    <Route
                        path="/logout"
                        render={ () => {
                        Dexie.delete("able_db");
                        return <div/>;
                        }}
                    />
                    <Redirect to="/profile" />
                    </Switch>
                    </div>
                
            </div>
            <Drawer 
                desktopType={Drawer.DrawerTypes.PERSISTENT}
                defaultVisible={true}
                visible={this.props.model.drawerVisible}
                mobileType={Drawer.DrawerTypes.TEMPORARY}
                onVisibilityChange={(x) => this.props.model.drawerVisible = x}
                onMediaTypeChange={(type, media) => {
                    if (type === Drawer.DrawerTypes.PERSISTENT) {
                    this.props.model.drawerVisible = true;
                    }
                }}
            >
                <NavDrawer 
                    items={items} 
                    user={this.props.model.user.name} 
                    organisationName={this.props.model.user.organisationName}   
                />
            </Drawer>
            </div>
        );
    }
    routesWithNoDrawer() {
        return(
        
            <div className="root">
                    <Switch>
                    <Route 
                        path="/admin" 
                        render={() => {
                            let model = new AppModel(this.props.model.servicesProvder);
                            return <App model={model} />;
                        }} 
                    />
                    <Route 
                        path={`/profile`}
                        render={(props) => {
                            this.props.model.headerTitle = "Profile";
                            this.profileViewModel.setServicesProvider(this.props.model.servicesProvder);
                            return  <Profile model={this.profileViewModel}/>; 
                        }} 
                    />
                    <Route
                        path="/logout"
                        render={ () => {
                        Dexie.delete("able_db");
                        return <div/>;
                        }}
                    />
                    <Redirect to="/profile" />
                    </Switch>
                    </div>
        );
    }
    render() {
        // tslint:disable-next-line:no-console
        const items = [];
        if (this.props.model.user.is_admin) {
            items.push({
                title: <NavLink key="Admin Portal" className='nav-element' to="/admin">Admin Portal</NavLink>
            });
        } 
        return (
            <div className="root">
                {
                    window.location.pathname.indexOf("admin") === -1 &&
                    this.routesWithDrawer(items)
                }
                {
                    window.location.pathname.indexOf("admin") > -1 &&
                    this.routesWithNoDrawer()
                }
            </div>
        );
    }
}

export default withRouter(Index);


// WEBPACK FOOTER //
// ./src/view/Index/Index.tsx